import { render, staticRenderFns } from "./CadastroRestritivo.vue?vue&type=template&id=48ef9e4f&"
import script from "./CadastroRestritivo.vue?vue&type=script&lang=js&"
export * from "./CadastroRestritivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports